<template>
    <v-tab-item :value="Corrosion.value">
        <v-container>
            <top-image :tit="Corrosion.text" bgImage="/images/sub/product/corrosion-bg.jpg" image="/images/sub/product/corrosion-img.jpg">
                <p class="page-text mb-6 mb-lg-20">
                    In the field of corrosion measurement, control, and prevention, various technical activities are used to manage the different corrosion causes and effects on materials and structures. These activities can be applied differently depending on the corrosion causes and the types of materials or structures involved.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Within the sphere of corrosion control and prevention, there are technical options such as cathodic and anodic protection, materials selection, chemical dosing and the application of internal and external coatings.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Corrosion measurement employs a variety of techniques to determine how corrosive the environment is and at what rate metal loss is being experienced.
                </p>
                <p class="page-text">
                    Corrosion measurement is the quantitative method by which the effectiveness of corrosion control and prevention techniques can be evaluated and provides the feedback to enable corrosion control and prevention methods to be optimized.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Product_TABS } from "@/assets/variables";
const { Corrosion } = Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            Corrosion,
        };
    },
};
</script>

<style scoped></style>
